import type { ParamEncoder } from 'axios';

export const encodeQueryParameter: ParamEncoder = (value, defaultEncoder) =>
  String(defaultEncoder(value)).replace(/%2B/gi, '+');
